import React, { useEffect, useState } from 'react'
import { Card, CardBody, Row, Col, CardHeader, Button, FormGroup, Input, Collapse, Label } from 'reactstrap'
import { Bounce, Loading, MsgSemRegistros, PageTitle, ReactCSSTransitionGroup, ReactDatatable, Select, moment, toast } from '../../Components'
import { BsSearch } from 'react-icons/bs'
import { FaEye } from 'react-icons/fa'
import { MdExpandLess, MdExpandMore } from 'react-icons/md'
import { ConversaGet, ConversaGetById, LaboratorioGet } from '../../Service/ApiService'
import { AppFooter, AppHeader, AppSidebar } from '../../Layout'
import ModalMsg from './ModalMensagens'
import { formatCnpj, formatTelefone } from '../../helpers/util'

const initValues = {
  laboratorioId: [],
  dtInicio: '',
  dtTermino: '',
  tpServico: '',
  situacao: [
    { value: 'S', label: 'Enviada Salesforce' },
    { value: 'C', label: 'Concluído' },
  ],
}
export default function FormCadastro() {
  const [isLoading, setIsLoading] = useState(false)
  const [isOpenFilter, setIsOpenFilter] = useState(false)
  const [modalMensagens, setModalMensagens] = useState({ show: false, messages: {} })
  const [dataGrid, setDataGrid] = useState([])
  const [values, setValues] = useState(initValues)
  const [laboratorios, setLaboratorios] = useState([])

  const columns = [
    {
      key: 'tpServico',
      text: 'Tipo de serviço',
      sortable: true,
      cell: (record) => {
        if (record.tpServico == 1) return 'Análises e Ensaios Laboratoriais'
        else if (record.tpServico == 2) return 'Serviços Tecnológicos'
        else return 'Indefinido'
      },
    },
    { key: 'laboratorioNm', text: 'Laboratório', sortable: true },
    {
      key: 'dhCadastro',
      text: 'Data',
      sortable: true,
      width: 100,
      cell: (record) => {
        if (record) return moment(record.dhCadastro).format('DD/MMM HH:mm')
      },
    },
    { key: 'cliNome', text: 'Nome', sortable: true },
    { key: 'cliEmail', text: 'Email', sortable: true },
    {
      key: 'nrTel',
      text: 'Telefone',
      sortable: true,
      cell: (d) => {
        if (d.nrTel) return formatTelefone(d.nrTel)
      },
    },
    {
      key: 'cliCnpj',
      text: 'CNPJ',
      sortable: true,
      cell: (d) => {
        return formatCnpj(d.cliCnpj)
      },
    },
    {
      key: 'situacao',
      text: 'Situação',
      sortable: true,
      cell: (record) => {
        if (record.dhEnvioExt != null) {
          return <span className="badge badge-success">Enviada Salesforce</span>
        } else if (record.cliEmail != null) {
          return <span className="badge badge-info">Concluída</span>
        } else if (record.dhEnvioExt == null && record.cliEmail == null) {
          return <span className="badge badge-warning">Em andamento</span>
        }
      },
    },
    {
      key: 'action',
      text: '',
      className: 'action',
      width: 40,
      align: 'left',
      sortable: false,
      cell: (record) => {
        return (
          <div>
            <button className="btn btn-primary btn-sm" onClick={() => filterMensagem(record.conversaId)}>
              <FaEye />
            </button>
          </div>
        )
      },
    },
  ]

  const config = {
    key_column: 'conversaId',
    page_size: 15,
    length_menu: [15, 30, 60],
    button: { excel: false },
    language: {
      loading_text: 'Aguarde, carregado ...',
      no_data_text: 'Sem registros',
      length_menu: 'Exibir _MENU_ registros',
      filter: 'Pesquisar ...',
      info: 'Exibindo _START_ até _END_ de _TOTAL_ registros',
      pagination: { first: '<<', previous: '<', next: '>', last: '>>' },
    },
  }

  async function loadLaboratorios(laboratorioId) {
    let itens = []
    let result = {}
    var response = await LaboratorioGet()
    response?.forEach((d) => {
      itens.push({ value: d.laboratorioId, label: d.nome })
      if (d.laboratorioId == laboratorioId) result = { value: d.laboratorioId, label: d.nome }
    })
    setLaboratorios(itens)
    return result
  }

  async function filterMensagem(id) {
    try {
      const response = await ConversaGetById(id)
      setModalMensagens({ show: true, messages: response.mensagens })
    } catch {
      toast('Erro ao carregar mensagens', { type: 'error', transition: Bounce, closeButton: true, autoClose: 5000, position: 'top-right' })
    }
  }

  async function loadGrid(filters = values) {
    let _filters = { ...filters }
    try {
      setIsLoading(true)
      _filters.laboratorioId = []
      filters.laboratorioId?.forEach((item) => {
        _filters.laboratorioId.push(item.value)
      })
      _filters.situacao = []
      filters.situacao?.forEach((d) => {
        _filters.situacao.push(d.value)
      })

      const response = await ConversaGet(_filters)
      setDataGrid(response)
    } catch (error) {}
    setIsLoading(false)
  }

  function onChange(ev) {
    const { name, value } = ev.target
    setValues({ ...values, [name]: value })
  }
  function onChangeCat(newValue, actionMeta) {
    const { name } = actionMeta
    setValues({ ...values, [name]: newValue })
  }
  function onModalMsg() {
    setModalMensagens({ show: false })
  }

  useEffect(() => {
    async function load() {
      try {
        setIsLoading(true)
        await loadLaboratorios()
        var _dtAtual = new Date()
        _dtAtual.setMinutes(_dtAtual.getMinutes() - _dtAtual.getTimezoneOffset())
        var _dhInicio2 = new Date(_dtAtual.getFullYear(), _dtAtual.getMonth(), 1)
        var _dhTermino2 = new Date(_dtAtual.getFullYear(), _dtAtual.getMonth() + 1, 1)
        _dhTermino2.setDate(_dhTermino2.getDate() - 1)
        var filters = { ...initValues, dhInicio: _dhInicio2.toISOString().substr(0, 10), dhTermino: _dhTermino2.toISOString().substr(0, 10) }

        setValues(filters)
        loadGrid(filters)
      } catch {}
      setIsLoading(false)
    }
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Loading isVisible={isLoading} />
      {modalMensagens.show && <ModalMsg change={onModalMsg} messages={modalMensagens.messages} />}

      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <ReactCSSTransitionGroup component="div" transitionName="TabsAnimation" transitionAppear={true} transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>
              <div className="body-tabs body-tabs-layout">
                <PageTitle heading="Painel de Conversas" subheading="Planejamento e acompanhamento de conversas" />
                <div className="page-content">
                  <Card className="main-card mb-1">
                    <CardHeader style={{ display: 'flex' }}>
                      Filtros
                      <Button
                        type="button"
                        onClick={() => {
                          loadGrid()
                          setIsOpenFilter(false)
                        }}
                        className="btn-pill"
                        color="primary"
                        id="btnPartPesquisar"
                        style={{ marginLeft: 'auto' }}
                      >
                        <BsSearch size={18} /> Buscar
                      </Button>
                      <Button
                        type="button"
                        onClick={() => setIsOpenFilter(!isOpenFilter)}
                        className="btn-transition btn-outline-primary btn-sm"
                        color="white"
                        id="btnPartPesquisar"
                        style={{ marginLeft: '10px' }}
                      >
                        {isOpenFilter ? <MdExpandLess size={22} /> : <MdExpandMore size={22} />}
                      </Button>
                    </CardHeader>
                    <Collapse isOpen={isOpenFilter}>
                      <CardBody>
                        <Row>
                          <Col md={2}>
                            <FormGroup>
                              <Label>Data de Início</Label>
                              <Input type="date" onChange={onChange} value={values.dhInicio} name="dhInicio" id="dhInicio" />
                            </FormGroup>
                          </Col>
                          <Col md={2}>
                            <FormGroup>
                              <Label>Data de Término</Label>
                              <Input type="date" onChange={onChange} value={values.dhTermino} name="dhTermino" id="dhTermino" />
                            </FormGroup>
                          </Col>
                          <Col md={3}>
                            <FormGroup>
                              <Label>Tipo serviço</Label>
                              <Input type="select" className="form-control" onChange={onChange} value={values.TpServico} id="TpServico" name="TpServico">
                                <option value=""></option>
                                <option value={1}>Análises e Ensaios Laboratoriais</option>
                                <option value={2}>Serviços Tecnológicos</option>
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col md={5}>
                            <FormGroup>
                              <Label>Situação</Label>
                              <Select
                                placeholder="Selecione"
                                noOptionsMessage={() => 'Nenhuma opção disponível'}
                                onChange={onChangeCat}
                                value={values.situacao}
                                isClearable
                                isMulti
                                closeMenuOnSelect={false}
                                name="situacao"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={[
                                  { value: 'S', label: 'Enviada Salesforce' },
                                  { value: 'C', label: 'Concluído' },
                                  { value: 'A', label: 'Em andamento' },
                                ]}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={12}>
                            <FormGroup>
                              <Label>Laboratórios</Label>
                              <Select
                                placeholder="Selecione"
                                noOptionsMessage={() => 'Nenhuma opção disponível'}
                                onChange={onChangeCat}
                                value={values.laboratorio}
                                isClearable
                                closeMenuOnSelect={false}
                                name="laboratorioId"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={laboratorios}
                                isMulti
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Collapse>
                  </Card>
                  <Card className="main-card">
                    <CardBody className="table-responsive">{dataGrid && dataGrid.length > 0 ? <ReactDatatable config={config} records={dataGrid} columns={columns} /> : <MsgSemRegistros />}</CardBody>
                  </Card>
                </div>
              </div>
            </ReactCSSTransitionGroup>
          </div>
          <AppFooter />
        </div>
      </div>
    </>
  )
}
